<template>
  <div class="tw-flex-col">
    <span class="tw-font-medium">{{ page.name }}</span>
    <div class="tw-flex tw-items-center justify-between font-inter tw-text-sm tw-gap-6">
      <div class="tw-whitespace-nowrap tw-font-medium">
        Include in presentation by default
      </div>
      <div>
        <o-switch
          :value="isIncluded"
          variant="success"
          position="left"
          @input="handleToggle"
        />
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'PageSetting',
  props: ['page'],
  data() {
    return {
      isIncluded: this.page.isIncluded,
    };
  },
  created() {
  },
  methods: {
    handleToggle(value) {
      this.isIncluded = value;
      this.$emit('updatePageSetting', this.page.name, value);
    },
  },
};
</script>


<style scoped>

</style>
